import { App } from "vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { createRouterGuards } from "./router-guards";
import Layout from "@/laylot/index.vue";

/**
 * 静态的路由：任何菜单权限下都能查看的界面路由
 */
const staticRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/tool"
  },
  {
    path: "/layout",
    name: "Layout",
    // 普通的路由加载
    component: Layout,
    children: [
      {
        path: "/home",
        name: "Home",
        meta: {
          title: "首页"
        },
        // 路由延迟加载（懒加载、按需加载）
        component: () => import("@/views/home/HomeMain.vue")
      },
      {
        path: "/column",
        name: "Column",
        meta: {
          title: "专栏"
        },
        component: () => import("@/views/column/ColumnMain.vue")
      },
      {
        path: "/tag",
        name: "tag",
        meta: {
          title: "标签"
        },
        component: () => import("@/views/tag/TagMain.vue")
      },
      {
        path: "/article",
        name: "Article",
        meta: {
          title: "文章"
        },
        component: () => import("@/views/article/ArticleMain.vue")
      },
      {
        path: "/collection",
        name: "Collection",
        meta: {
          title: "收藏"
        },
        component: () => import("@/views/collection/CollectionMain.vue")
      },
      {
        path: "/tool",
        name: "Tool",
        meta: {
          title: "工具"
        },
        component: () => import("@/views/tool/ToolMain.vue")
      },
      {
        path: "/manage",
        name: "Manage",
        meta: {
          title: "管理"
        },
        component: () => import("@/views/manage/ManageMain.vue")
      }
    ]
  },
  {
    path: "/write",
    name: "Write",
    meta: {
      title: "创作"
    },
    component: () => import("@/views/write/WriteMain.vue")
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: staticRoutes
});

export function setupRouter(app: App) {
  app.use(router);
  // 创建路由守卫
  createRouterGuards(router);
}

export default router;
